module.exports = __webpack_public_path__ + "img/awards_trophy1.f7c1f969.png";